import { View, StyleSheet } from 'react-native';
import { Spinner, theme } from '@socrait/react';

interface LoadingProps {
  backgroundColor?: string;
}

export function Loading({ backgroundColor = theme.colors.background }: LoadingProps) {
  return (
    <View style={[styles.container, { backgroundColor }]}>
      <Spinner />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
